import { useContext } from "react";
import classNames from "classnames";

import { MapContext } from "../../../../Map";
import KeyboardButton from "../KeyboardButton/KeyboardButton";
import styles from "./HrHRKeyboard.module.scss";
import { KeyboardType } from "../../Keyboard";

interface Props {
  handleClick: (...args: any[]) => void;
  handleBackspace: (...args: any[]) => void;
  handleKeyboardTypeSwitch?: (type: KeyboardType) => void;
  handleSearch: () => void;
  showSearchKey?: boolean;
  searchDisabled?: boolean;
}

const HrHRKeyboard: React.FC<Props> = ({
  handleClick,
  handleBackspace,
  handleKeyboardTypeSwitch,
  handleSearch,
  showSearchKey = true,
  searchDisabled = false,
}) => {
  const { controlTheme } = useContext(MapContext);

  return (
    <div className={classNames(styles.container, styles[controlTheme])}>
      <div className={styles.backdrop} />
      <div className={classNames(styles.row, styles.rowOne)}>
        <KeyboardButton type="text" text="q" onClick={handleClick} />
        <KeyboardButton type="text" text="w" onClick={handleClick} />
        <KeyboardButton type="text" text="e" onClick={handleClick} />
        <KeyboardButton type="text" text="r" onClick={handleClick} />
        <KeyboardButton type="text" text="t" onClick={handleClick} />
        <KeyboardButton type="text" text="z" onClick={handleClick} />
        <KeyboardButton type="text" text="u" onClick={handleClick} />
        <KeyboardButton type="text" text="i" onClick={handleClick} />
        <KeyboardButton type="text" text="o" onClick={handleClick} />
        <KeyboardButton type="text" text="p" onClick={handleClick} />
      </div>

      <div className={classNames(styles.row, styles.rowTwo)}>
        <KeyboardButton type="text" text="a" onClick={handleClick} />
        <KeyboardButton type="text" text="s" onClick={handleClick} />
        <KeyboardButton type="text" text="d" onClick={handleClick} />
        <KeyboardButton type="text" text="f" onClick={handleClick} />
        <KeyboardButton type="text" text="g" onClick={handleClick} />
        <KeyboardButton type="text" text="h" onClick={handleClick} />
        <KeyboardButton type="text" text="j" onClick={handleClick} />
        <KeyboardButton type="text" text="k" onClick={handleClick} />
        <KeyboardButton type="text" text="l" onClick={handleClick} />
      </div>

      <div className={classNames(styles.row, styles.rowThree)}>
        <div className={styles.rowThreeKeys}>
          <KeyboardButton type="text" text="y" onClick={handleClick} />
          <KeyboardButton type="text" text="x" onClick={handleClick} />
          <KeyboardButton type="text" text="c" onClick={handleClick} />
          <KeyboardButton type="text" text="v" onClick={handleClick} />
          <KeyboardButton type="text" text="b" onClick={handleClick} />
          <KeyboardButton type="text" text="n" onClick={handleClick} />
          <KeyboardButton type="text" text="m" onClick={handleClick} />
        </div>
        <KeyboardButton
          dataQA="backspace"
          type="icon"
          icon="backspace"
          value=""
          onClick={handleBackspace}
          className={styles.backspaceKey}
        />
      </div>

      <div className={classNames(styles.row, styles.rowFour)}>
        <div className={classNames(styles.column, styles.columnOne)}>
          <KeyboardButton
            dataQA="numeric-switch"
            type="text"
            text="123"
            onClick={
              handleKeyboardTypeSwitch
                ? () => handleKeyboardTypeSwitch("numeric")
                : handleClick
            }
            className={styles.numericSwitchKey}
          />
        </div>
        <div className={classNames(styles.column, styles.columnTwo)}>
          <KeyboardButton
            dataQA="space"
            type="text"
            text=""
            onClick={() => handleClick({ currentTarget: { name: " " } })}
            className={styles.spaceKey}
            verticalAlign={false}
          />
          <KeyboardButton
            dataQA="search"
            type="icon"
            icon="search"
            value=""
            onClick={showSearchKey ? handleSearch : () => {}}
            className={classNames(styles.searchKey, {
              [styles.searchKeyHidden]: !showSearchKey,
            })}
            disabled={!showSearchKey || searchDisabled}
          />
        </div>
      </div>
    </div>
  );
};

export default HrHRKeyboard;
